import * as Tgcc from '../tgccGlobal';
import * as React from 'react';
import Radium, { StyleRoot } from 'radium';
import {CSSProperties} from 'react';

type CardProps = {
    brand: Tgcc.ProductBrand;
    onSelect?: (brand: Tgcc.ProductBrand) => void;
}

const wrapperStyle: CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundColor: 'white',
    width: '185px',
    height: '185px',
    fontFamily: 'CenturyGothic',
    boxShadow: Tgcc.Styles.boxShadow,
    margin: '5px',
    '@media (max-width:800px) and (max-height:1280px)': {
        margin:'auto auto 10px auto'
    },
    '@media (max-width:768px) and (max-height:1366px)': {
        margin:'auto auto 10px auto'
    },
    '@media (max-width:768px) and (max-height:1024px)': {
        margin:'auto auto 10px auto'
    },
    '@media (max-width:414px)': {
        margin:'auto auto 10px auto'
    }
};

const logoStyle: CSSProperties = {
    height: '25px',
    lineHeight: '25px',
    fontFamily: 'CenturyGothic',
    fontSize: '20px',
    letterSpacing: '8px'
};

const contentStyle: CSSProperties = {
    height: '165px',
    width: '165px',
    marginLeft: '10px',
    border: Tgcc.Styles.singleBorder,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    cursor: 'pointer',
};

const brandTextStyle: CSSProperties = {
    height: '40px',
    fontSize: '24px',
    lineHeight: '40px',
    letterSpacing: '5px',
};

const imageStyle: CSSProperties = {
    maxHeight: '90%',
    maxWidth: '90%'
};


class _BrandCard extends React.Component<CardProps, any>{
    
    handleSelection = (evt) => {
        if(this.props.onSelect)
            this.props.onSelect(this.props.brand);
    }

    render(){
        let cardHeader = null;
        let cardImage = this.props.brand.image;
        let cardName = this.props.brand.brand;
        let brandImage = null;
        let brandLabel = null;
        if(cardImage){
            let hint = 'view products by ' + this.props.brand.brand;
            brandImage = <img style={imageStyle} src={cardImage.replace(' ', '').replace('+','').replace('&','')} title={hint} alt={hint} />;
        } else {
            brandLabel = <div style={brandTextStyle}>{cardName}</div>;
        }

        return (
            <div style={wrapperStyle}>
                <div style={contentStyle} onClick={this.handleSelection}>
                    {brandImage}
                    {brandLabel}
                </div>
            </div>
        )
    }
}
export var BrandCard = Radium(_BrandCard);